import EnlilAxios from "../../../../util/EnlilAxios";
import {V1DeveloperEventConfigurationIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";


class DeveloperEventConfigurationEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let fk = {};
        if (this.enterpriseObject !== null) {
            let relationship = this.enterpriseObject.getRelationshipForEnterpriseComponent(this);

            if (relationship) {
                fk[relationship.getDestinationAttribute()] = foreignKey;
            }
        }

        EnlilAxios({
            method: "GET",
            url: "t2/v1/developer_event_configurations",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...(foreignKey ? fk : {}),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.DeveloperEventConfiguration-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1DeveloperEventConfigurationIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    }

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.DeveloperEventConfiguration-001";
        payload.ShifamedMessage.DeveloperEventConfiguration = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t2/v1/developer_event_configurations",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.DeveloperEventConfiguration-001",
                "idoc-response": "v1.DeveloperEventConfiguration-001",
            },
        };
        this.notifyUpdateStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1DeveloperEventConfigurationIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let developerEventConfiguration = {};

        developerEventConfiguration["USID"] = this.getAttributeValue("USID");
        developerEventConfiguration["DeveloperEventUSID"] = this.getEnterpriseObject().getEnterpriseComponent("DeveloperEvent").getAttributeValue("USID");
        developerEventConfiguration["ConfigurationName"] = this.getAttributeValue("ConfigurationName");
        developerEventConfiguration["ConfigurationValue"] = this.getAttributeValue("ConfigurationValue");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.DeveloperEventConfiguration-001";
        payload.ShifamedMessage.DeveloperEventConfiguration = developerEventConfiguration;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t2/v1/developer_event_configurations",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.DeveloperEventConfiguration-001",
                "idoc-response": "v1.DeveloperEventConfiguration-001",
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1DeveloperEventConfigurationIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentDeleteIDOC = () => {
        let payload = {};

        let developerEventConfiguration = {};

        developerEventConfiguration["USID"] = this.getAttributeValue("USID");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.DeveloperEventConfiguration-001";
        payload.ShifamedMessage.DeveloperEventConfiguration = developerEventConfiguration;

        return payload;
    };

    performDelete() {
        let payload = this.enterpriseComponentDeleteIDOC();

        let options = {
            method: "DELETE",
            url: "t2/v1/developer_event_configurations",
            json: true,
            data: payload,
            headers: {},
        };
        this.notifyDeleteStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default DeveloperEventConfigurationEnterpriseComponent;